import { useSession } from "shared/hooks/useSession";

// Валюта заведения — как и локаль, свойство сессии (см. useLocale).
export const DEFAULT_CURRENCY_ID = "RUB";

export const useCurrencyId = (): string => {
    const { account } = useSession();

    return account ? account.currencyId : DEFAULT_CURRENCY_ID;
};
